import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import AboutArt from "@/pages/home/components/AboutArt";
import ProjectNav from "@/components/feature/ProjectNav";

export default function BioPage() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <AboutArt />
        <ProjectNav
          prev={{ label: "Mmnto.Mori", to: "/mmnto-mori" }}
          next={{ label: "Home", to: "/" }}
        />
      </main>
      <Footer />
    </div>
  );
}